import { render, staticRenderFns } from "./ReceitaTotal.vue?vue&type=template&id=bd56c1d4"
import script from "./ReceitaTotal.vue?vue&type=script&lang=js"
export * from "./ReceitaTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports